import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { CMSTabParagraphContainer, CmsService, Product, WindowRef } from '@spartacus/core';
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  CurrentProductService,
  TabParagraphContainerComponent
} from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { fadeIn, fadeOut } from '../../../../../custom/animation/custom-animations';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';

@Component({
  selector: 'app-custom-tab-paragraph-container',
  templateUrl: './custom-tab-paragraph-container.component.html',
  styleUrls: ['./custom-tab-paragraph-container.component.scss'],
  animations: [fadeIn, fadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomTabParagraphContainerComponent extends TabParagraphContainerComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  product$: Observable<Product>;
  iconTypes = ICON_TYPE;
  showTab = false;
  changeIcon = false;

  constructor(
    public componentData: CmsComponentData<CMSTabParagraphContainer>,
    protected cmsService: CmsService,
    protected winRef: WindowRef,
    protected breakpointService: BreakpointService,
    protected currentProductService: CurrentProductService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super(componentData, cmsService, winRef);
    this.product$ = this.currentProductService.getProduct();
  }

  select(tabNum: number, event?: MouseEvent): void {
    if (tabNum !== this.activeTabNum) {
      this.activeTabNum = tabNum;
      this.showTab = true;
      this.changeIcon = true;
    } else {
      this.showTab = !this.showTab;
      this.changeIcon = !this.changeIcon;
    }
    this.subscriptions.add(this.breakpointService
      ?.isDown(BREAKPOINT.sm)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          if (event && event?.target) {
            const target = event.target as HTMLElement;
            const parentNode = target.parentNode as HTMLElement;
            let topOffset = 10; // Distance from the node to the header;
            const headerNavigation = this.winRef.document.getElementById('wrapper-navigation');
            if (headerNavigation) {
              topOffset += headerNavigation.offsetHeight;
            }
            if (isPlatformBrowser(this.platformId)) {
              setTimeout(() => { // Delay until selected tab shows
                scroll({
                  top: parentNode?.offsetTop - topOffset,
                  behavior: 'smooth',
                });
              }, 10);
            }
          }
        }
      }));
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
